import { gql } from 'graphql-request'
import { GenericBlock } from './generic'
import { ExcludedPlatforms } from 'app/types/excludedPlatforms'

export const justUpdatedSeriesFragment = gql`
  fragment justUpdatedSeriesFragment on JustUpdatedSeries {
    id
    title
    collections {
      name
      subtitle
      slug
      thumbnail {
        id
        sizes {
          square {
            url
          }
        }
      }
      itemCount
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface JustUpdatedSeries extends GenericBlock<'JustUpdatedSeries'> {
  title: string
  collections: any[]
  excludedPlatforms: ExcludedPlatforms
}
